import React from 'react';
import { DNABox, DNAButton, DNAText, Iffy } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors'
import { DNAChip, DNAPopover } from 'src/components/DNA';

export const RightGroupMenu: React.FC<{
  pages: number,
  locked: boolean,
  onAdd?: () => void,
  onDelete?: () => void,
}> = (props) => {
  const { locked, pages, onAdd, onDelete } = props
  return (
    <DNABox spacing="between">
      <DNABox alignX="center" alignY="center" style={{ marginRight: 4 }} fill childFill>
        <DNAChip.Beacon children={`${pages}`} />
      </DNABox>
      <DNAPopover>
        <DNAPopover.Anchor>
          <DNAButton
            appearance="ghost"
            status="subtle"
            iconLeft={locked ? 'lock' : 'lock-simple-open'}
            disabled
          />
        </DNAPopover.Anchor>
        <DNAPopover.Content>
          <DNAText style={{ color: colors['color-text-white'] }}>
            {locked ? 'Ungrouping restricted' : 'Ungrouping allowed'}
          </DNAText>
        </DNAPopover.Content>
      </DNAPopover>
      <Iffy is={onDelete}>
        <DNAPopover>
          <DNAPopover.Anchor>
            <DNAButton
              appearance="ghost"
              status="subtle"
              iconLeft="trash"
              onPress={onDelete}
            />
          </DNAPopover.Anchor>
          <DNAPopover.Content>
            <DNAText style={{ color: colors['color-text-white'] }}>
              delete group
            </DNAText>
          </DNAPopover.Content>
        </DNAPopover>
      </Iffy>
      <Iffy is={onAdd}>
        <DNAPopover>
          <DNAPopover.Anchor>
            <DNAButton
              appearance="ghost"
              size="lg"
              iconLeft="arrow-right"
              onPress={onAdd}
            />
          </DNAPopover.Anchor>
          <DNAPopover.Content>
            <DNAText style={{ color: colors['color-text-white'] }}>
              Select with this group
            </DNAText>
          </DNAPopover.Content>
        </DNAPopover>
      </Iffy>
    </DNABox>
  )
}
